module.exports = __webpack_public_path__ + "fonts/iconfont.e45b162a.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.eot?t=1571105669105
// module id = VGI+
// module chunks = 240